export default {
    "首页":"首頁",
    "发展历史":"發展歷史",
    "资质荣誉":"資質榮譽",
    "宣传视频":"宣傳影片",
    "新闻资讯":"新聞資訊",
    "产品展示":"產品展示",
    "客户案例":"客戶案例",
    "下载中心":"下載中心",
    "联系我们":"聯繫我們",
    "公司":"公司",
    "联系人":"聯繫人",
    "传真":"傳真",
    "邮件":"郵件",
    "邮政编码":"郵政編碼",
    "网址":"網址",
    "地址":"地址",
    "在线留言":"在線留言",
    "标题":"標題",
    "请填写标题":"請填寫標題",
    "姓名":"姓名",
    "请填写姓名":"請填寫姓名",
    "电话":"電話",
    "请填写电话":"請填寫電話",
    "内容":"內容",
    "请填写内容":"請填寫內容",
    "提交消息":"提交消息",
    "邮箱":"郵箱",
    "来源":"來源",
    "创建时间":"創建時間",
    "点击量":"點擊量",
    "属于":"屬於",
    "上一条":"上一條",
    "下一条":"下一條",
    "产品ID":"產品ID",
    "购买价格":"購買價格",
    "发布时间":"發布時間",
    "下载":"下載",
    "暂无下一条数据":"暫無下一條數據",
    "暂无上一条数据":"暫無上一條數據",
    "登录":"登陸",
}